var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.668 5.423c-1.196-.87-3.914-.652-5.219.218C6.795.314 12.666 9.663 14.732 9.663h9.784c1.522 0 7.067-8.697-1.848-4.24Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.731 12.707c-1.522 0-1.522-2.174 0-2.174h9.676c1.413 0 1.413 2.174 0 2.174H14.73Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.97 13.577c-31.744 30.114 43.813 29.68 10.98 0H13.97Zm9.676 12.068c.109 2.065-1.522 3.044-3.37 3.152 0 .653.109 1.414-.761 1.414s-.761-.761-.761-1.414c-1.087 0-2.283-.434-2.935-1.304-1.305-1.74.652-3.044 1.522-1.522 1.087 1.957 4.022 1.522 4.022.326 0-2.283-5.87-.979-5.87-4.457 0-1.849 1.63-2.718 3.261-2.827 0-.543-.109-1.522.76-1.522.87 0 .762.979.762 1.63.978.11 2.174.544 2.718 1.305.87 1.414-.653 2.175-1.523 1.522-.87-.652-.87-1.413-2.282-1.413-.544 0-1.414.326-1.523.979-.108 1.74 5.654.978 5.98 4.13Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.99e35ebeeb9797aa1284e1456d9c9733.svg";
export { ForwardRef as ReactComponent };